import { UseQueryOptions } from '@tanstack/react-query';
import clientsApi from '@/features/dashboard/clients/api/clientsApi.ts';
import { clientsApiQueryKeys } from '@/features/dashboard/clients/api/clientsApi.queryKeys.ts';
import { ClientDetailsDto } from '@/features/dashboard/clients/types/ClientDetailsDto.ts';

export const getClientDetailsQueryOptions = (
  clientId: string,
): UseQueryOptions<ClientDetailsDto> => ({
  queryKey: clientsApiQueryKeys.details(clientId),
  queryFn: () => clientsApi.getClient(clientId),
  enabled: clientId !== undefined,
});
